<template>
	<div class="propaganda">
		<Vplayer :datainfo="currentVideo" :isShow="isShow" @close="onClose" v-if="!!currentVideo"></Vplayer>
		<changeNav />
		<Carousel>
			<template slot="titleTxt">
				<div class="title-box">
					<img src="~@/assets/image/videoimg.png" alt="" width="96" height="23" class="title-img" />
					<span class="title-txt">Video promotion</span>
				</div>
			</template>
		</Carousel>
		<!--导航开始-->
		<Breadcrumb />
		<!--导航开始结束-->

		<!--视频宣传开始-->
		<div class="publicity_con">
			<div class="publicity_nav clearfix">
				<div class="tab">
					<a class="item" v-for="(item,index) in categoryList" :key="index" @click="changeType(item.code,index)" :class="{on:index==currentIndex }">{{item.name}}</a>
				</div>
				<div class="publicity_new">
					<div v-show="noData">当前没有数据</div>
					<ul class="publicity_list clearfix" v-show="!noData">
						<li class="publicity_item" v-for="(item,index) in videoListShow" :key="index" @click="playVideo(item)">
							<div class="image_con">
								<img :src="item.imageUrl" alt="" width="330" height="180" class="title-img" />
								<div class="item_mask">
									<img src="~@/assets/image/video_play.png" alt="" width="49" height="49">
								</div>
							</div>
							<div class="publicity_text publicity_item_title">{{item.title}}</div>
						</li>
					</ul>

					<!--分页开始-->
					<div class="block" v-if="!noData">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
						 :page-size="pageSize" layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<!--分页结束-->


				</div>
			</div>
		</div>
		<!--新闻动态结束-->

	</div>
</template>

<script>
	import changeNav from '@/components/changeNav.vue';
	import Carousel from '@/components/Carousel.vue';
	import Breadcrumb from '@/components/Breadcrumb.vue';
	import Vplayer from '@/components/Vplayer.vue';
	import {
		GetVideoPromotionList
	} from '../Home/Home.model';
	import {
		GetVideoCategoryList
	} from './Propaganda.model';
	import {
		API_HOST
	} from '@/assets/Utils/api/config.js'

	export default {
		name: "Propaganda",
		components: {
			changeNav,
			Carousel,
			Breadcrumb,
			Vplayer
		},
		metaInfo: {
			title: '福建省越盛智能科技有限公司', // set a title
			meta: [{ // set meta
				name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
				content: '视频宣传'
			}],
			link: [{ // set link
				rel: 'asstes',
				href: 'http://www.fjyszn.com/'
			}]
		},
		data() {
			return {
				isShow: false,
				currentVideo: null,
				currItem: null,
				categoryList: [],
				videoListShow: [],
				currentIndex: 0,
				noData: false,
				currentPage: 1,
				totalCount: 0,
				totalPage: 0,
				pageSize: 0,
				videoType: "videotypeCode1"
			}
		},
		async mounted() {
			var videoCategoryData = await GetVideoCategoryList();
			this.categoryList = videoCategoryData.data.list;
			this.chageData(this.videoType, 0);
		},
		methods: {
			handleSizeChange() {
			},
			handleCurrentChange(curPage) {
				this.currentPage = curPage
				this.chageData(this.videoType, this.currentPage);
			},
			closePlay() {
				// console.log(closePlay);
			},
			changeType(type, index) {
				this.videoType = type;
				 this.currentIndex = index;
				 this.currentPage = 1;
				this.chageData(type, this.currentPage);
			},
			async chageData(type, index) {
				let param = {
					page: index,
					limit: 9,
					typeCode: type
				};
				var videoList = await GetVideoPromotionList(param);
				this.videoListShow = videoList.data.list;
				this.totalCount = videoList.data.totalCount;
				this.totalPage = videoList.data.totalPage;
				this.pageSize = videoList.data.pageSize;
				this.noData = false;
				if (this.videoListShow == 0) {
					this.noData = true;
				}
			},
			playVideo(item, index) {
				this.currItem = item;
				this.isShow = true;
				this.currentVideo = this.currItem;
			},
			onClose() {
				this.isShow = false
			}
		}
	}
</script>

<style scoped lang="less">
	.title-box {
		text-align: left;
		height: 80px;
		line-height: 80px;

		img {
			vertical-align: middle;
		}

		span {
			vertical-align: middle;
			color: #CCC;
			font-size: 16px;
			display: inline-block;
			margin-left: 15px;
			line-height: 24px;
			margin-top: 10px;
		}
	}

	.publicity_con {
		width: 1240px;
		margin: 0px auto;
	}

	.publicity_nav {
		/*border:1px solid red;*/
		margin-bottom: 80px;
	}

	.tab {
		width: 190px;
		float: left;
		margin-right: 20px;

		.item {
			font-size: 14px;
			color: #B3B3B3;
			display: block;
			line-height: 54px;
			border-bottom: 1px solid #E6E6E6;
			width: 190px;
			height: 54px;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 0px 0px rgba(230, 230, 230, 1);
			text-decoration: none;
			cursor: pointer;
			position: relative;
			text-align: left;
			text-indent: 55px;

			&:first-child {
				border-top: 1px solid #E6E6E6;
			}

			&:hover {
				/*color:#39B2EC;*/
				color: #39B2EC;
			}
		}

		.item.on {
			position: relative;
			color: #39B2EC;

			&::before {
				content: " ";
				display: block;
				width: 6px;
				height: 6px;
				background: #39b2ec;
				position: absolute;
				top: 25px;
				left: 38px;
				border-radius: 50%;
			}
		}
	}

	.publicity_new {
		float: left;
		width: 1030px;
		overflow: hidden;

		.publicity_list {
			width: 1050px;
		}

		.publicity_item {
			float: left;
			width: 330px;
			height: 220px;
			margin-right: 20px;
			margin-bottom: 40px;

			&:hover {
				.item_mask {
					display: block;
				}
			}

			.image_con {
				position: relative;

				img {
					display: block;
				}

				.item_mask {
					position: absolute;
					top: 0px;
					left: 0px;
					right: 0px;
					bottom: 0px;
					background: rgba(0, 0, 0, 0.5);
					display: none;

					img {
						position: absolute;
						top: 50%;
						margin-top: -25px;
						left: 50%;
						margin-left: -25px;
					}
				}
			}

			.publicity_item_title {
				font-size: 14px;
				font-weight: 500;
				color: rgba(51, 51, 51, 1);
				line-height: 24px;
				text-align: left;
				margin-top: 15px;
			}

			&:hover {
				.image_con {
					position: relative;

					img {
						display: block;
					}

					.item_mask {
						display: block;
					}
				}
			}
		}
	}
  .el-pagination{
		 margin-top:30px;
		 color:#B3B3B3;
		 font-size:14px;
	}
	.el-pagination__total{
		color: #333333!important;
	}
	.el-pagerr{
      li{
				border:1px solid red;
				color: #B3B3B3;
				font-weight:500
				&.number {
					color: #B3B3B3!important;
				}
				&.active {
					color: #39B2EC!important;
				}
			}
	} 
</style>
